import { FC } from 'react';
import { BoxProps, Box } from '@mui/material';

import { Image } from '../Media/Image';


export const DirigoLogo: FC<BoxProps<'img'>> = (props) => {
  return (
    <Box height={40}>
      <Image
        display="block"
        margin="0 auto"
        width="auto"
        src="/assets/dirigo.png" alt="Dirigo Logo" {...props}
      />
    </Box>
  );
};
